<template>
  <div class="outer-play">
    <div class="playList">
      <div
        class="videoList"
        v-for="(item, index) in playList"
        :key="index"
        @click="playVideo(item)"
      >
        <div class="pause">
          <img class="pauseImg" src="../../assets/icon_zt.png" alt="" />
        </div>
        <img class="pic" :src="item.iconUrl" alt="" />
        <div class="title" :class="item.productId == value ? 'isPlay' : ''">
          {{ item.productName }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    playList: null,
    value: null,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      isPlay: false,
    };
  },
  methods: {
    playVideo(params) {
      console.log("playVideo---", params);
      this.getFileUrl(params);
      // params.isPlay = true
    },
    // 获取文件链接
    async getFileUrl(params) {
      console.log("getFileUrl-", params);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const res = await this.$http.getFileUrl({
        fileName: params.productUrl,
      });
      loading.close();
      if (res.data.code === "0") {
        // console.log("getFileUrl--fileUrl-", res.data.data.fileUrl);
        params.productUrl = res.data.data.fileUrl;
        // console.log("playVideo--after-", params);
        if (this.$route.query.id == params.productId) {
          this.$message("正在播放当前视频");
        } else {
          this.$emit("getVideoInfo", params);
        }
      } else {
        this.$message.error(res.data.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.outer-play {
  overflow: hidden;
  .playList {
    width: 367px;
    display: inline-block;
    position: fixed;
    top: 56px;
    bottom: 0;
    overflow: scroll;
    right: 80px;
    z-index: 1;
    .videoList {
      position: relative;
      font-size: 26px;
      font-family: "Source Han Sans CN";
      font-weight: 400;
      color: #19202c;
      opacity: 1;
      .pause {
        position: absolute;
        left: 50%;
        right: 50%;
        top: 70px;
        transform: translateX(-50%);
        width: 80px;
        height: 80px;
        background: rgba($color: #000000, $alpha: 0.2);
        border-radius: 50%;
        border: 1px solid #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 36px;
          height: 36px;
          display: block;
          margin-left: 2px;
        }
      }
      .pic {
        width: 367px;
        height: 213px;
        display: block;
      }
      .title {
        margin: 16px 0 32px 0;
      }
      .isPlay {
        color: #308fff;
      }
    }
  }
}
</style>
